// extracted by mini-css-extract-plugin
export default {"actions":"DeleteConfirm_actions__CZVfI","inputContainer":"DeleteConfirm_inputContainer__ZjC4n","main":"DeleteConfirm_main__voOL8"};